<div id="midi-chord-detect-abc-style">
    <div [ngClass]="(cm.is_midi_guitar())?'simpleStave':'doubleStaves'" >
        <div id="midi-chord-detect-abc" style="min-height: 900px;"> </div>
    </div>
</div>
